import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Chat from './components/Chat';
import Home from './components/Home';

function App() {
  return (
    <Router>
      <Routes>
        {/* Main Chat Interface */}
        <Route path="/" element={<Home />} />
        <Route path="/chat" element={<Chat />} />
        
        {/* Chat Interface with an active session */}
        <Route path="/chat/:sessionId" element={<Chat />} />

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;